/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppointmentsAliases {
  BREADCRUMB_APPOINTMENTS = 'breadcrumb-appointments',
  DATE_FIELD_RESULT = 'date-field-result',
  DATE_PICKER_APPOINTMENT_RANGE = 'date-picker-appointment-range',
  DECK_BLOCKED_ITEMS = 'deck-blocked-items',
  DECK_CHOOSEN_ITEMS = 'deck-choosen-items',
  FIELD_DATEFIELD_RESULT = 'field-datefield-result',
  FORM_DATEFIELD_RESULT = 'form-datefield-result',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  LAYOUT_APPOINTMENTS = 'layout-appointments',
  LAYOUT_STEP_DATE = 'layout-step-date',
  LAYOUT_STEP_SUGGESTION = 'layout-step-suggestion',
  LINK_CALL_WAITING_LIST = 'link-call-waiting-list',
  LOADER_FINAL = 'loader-final',
  MAPPER_CHOOSEN_ITEM = 'mapper-choosen-item',
  PANEL_3_RESULT = 'panel-3-result',
  PANEL_BLOCKED_ITEMS = 'panel-blocked-items',
  PANEL_DECK = 'panel-deck',
  PANEL_LOADER = 'panel-loader',
  PANEL_NOTIFICATION_STEP_DATE = 'panel-notification-step-date',
  PANEL_NOTIFICATION_STEP_SUGGESTION = 'panel-notification-step-suggestion',
  PANEL_TOTAL = 'panel-total',
  SUGGESTION_CARD_ITEM_BLOCKED_ITEMS_APPOINTMENTS = 'suggestion-card-item-blocked-items-appointments',
  SUGGESTION_CARD_ITEM_CHOOSEN_ITEM_APPOINTMENTS = 'suggestion-card-item-choosen-item-appointments',
  TEXT_TOTAL = 'text-total',
  TOAST_NOTIFICATION_STEP_SUGGESTION_WAITING_LIST = 'toast-notification-step-suggestion-waiting-list',
  TOAST_NOTIFICATION_WAITING_LIST = 'toast-notification-waiting-list',
  WIZARD_APPOINTMENTS = 'wizard-appointments',
  WIZARD_STEP_DATE = 'wizard-step-date',
  WIZARD_STEP_SUGGESTION = 'wizard-step-suggestion',
}
export { AppointmentsAliases };
